import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Play, Brain, Gamepad2, HelpCircle, Users } from "lucide-react";
import { CATEGORIES } from "@/data/games";

const ICONS = { arcade: Gamepad2, brain: Brain, quiz: HelpCircle };

export function GameCard({ item, index = 0 }) {
  const isQuiz = item.type === "quiz";
  const to = isQuiz ? `/quiz/${item.id}` : `/play/${item.id}`;
  const cat = CATEGORIES[item.category];
  const Icon = ICONS[item.category] || Gamepad2;

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: (index % 8) * 0.06 }}
    >
      <Link
        to={to}
        data-testid={`game-card-${item.id}`}
        className="group block bg-zinc-950 border-2 border-zinc-800 hover:border-neon-cyan rounded-xl overflow-hidden transition-all duration-300 hover:shadow-[6px_6px_0px_0px_rgba(0,240,255,1)] hover:-translate-y-1"
      >
        <div className="relative aspect-video overflow-hidden">
          <img src={item.image} alt={item.title} loading="lazy"
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
          <span className="absolute top-3 left-3 flex items-center gap-1 px-2 py-1 text-[10px] font-bold uppercase tracking-widest bg-black/80 border rounded"
            style={{ color: cat.color, borderColor: cat.color }}>
            <Icon className="w-3 h-3" /> {cat.label}
          </span>
          {item.type === "versus" && (
            <span className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 text-[10px] font-bold uppercase tracking-widest bg-neon-pink text-white rounded">
              <Users className="w-3 h-3" /> 2P
            </span>
          )}
          {item.tag && item.type !== "versus" && (
            <span className="absolute top-3 right-3 px-2 py-1 text-[10px] font-bold uppercase tracking-widest bg-black/80 text-white border border-zinc-600 rounded">
              {item.tag}
            </span>
          )}
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
            <span className="flex items-center gap-2 px-5 py-2.5 bg-neon-cyan text-black font-bold uppercase tracking-widest text-sm rounded-full">
              <Play className="w-4 h-4 fill-black" /> Play Now
            </span>
          </div>
        </div>
        <div className="p-4">
          <h3 className="font-display font-bold text-lg uppercase tracking-tight group-hover:text-neon-cyan transition-colors">{item.title}</h3>
          <p className="text-sm text-zinc-500 mt-1 line-clamp-2">{item.blurb}</p>
        </div>
      </Link>
    </motion.div>
  );
}
